<i18n>
{
    "de": {
        "Gross price": "Brutto-Preis",
        "Net price": "Netto-Preis",
        "Tax rate": "Steuersatz",
        "Regular": "Regulär",
        "Reduced": "Vermindert",
        "Type": "Art",
        "Sale date range": "Angebotszeitraum",
        "Starts At": "Beginnt am",
        "Ends At": "Endet am",
        "min. Quantity": "min. Bestellmenge",
        "pcs.": "stk.",
        "Customer group": "Kundengruppe",
        "Customer group price": "Kundengruppenpreis",
        "Inherit": "Wie Produkt"
    }
}
</i18n>

<script>
import Price from '@/extensions/shop/views/Product/Form/Partials/Price'

export default {
    name: 'Price',
    extends: Price,
    props: {
        optionsProp: {
            type: Object,
            required: true
        },
        disabledCustomerGroupIds: {
            type: Array,
        },
        inheritedTax: {
            type: Object,
        },
    },
    computed: {
        // An attribute price is a surcharge nothing is asked for: no "Preis auf Anfrage".
        showPriceOnRequest() {
            return false;
        },
        priceNetValue: {
            get() {
                if (!this.inheritedTax) return null

                const grossValue = this.price.value;
                const taxRate = this.inheritedTax.value;

                let value = null;
                if (grossValue) value = _.round((grossValue * 100) / (100 + taxRate), 2);

                return value;
            },
            set(value) {
                if (!this.inheritedTax) return null

                const taxRate = this.inheritedTax.value;
                if (value) value = _.round((value / 100) * (100 + taxRate), 2);
                this.update(this.price, 'value', parseFloat(value));
            }
        },
        priceType() {
            return 'group'
        },
        options() {
            return this.optionsProp;
        },
        typeOptions() {
            // let types = _.filter(this.options.priceType.items, item => item.value !== 'main');
            // types = _.cloneDeep(types);

            // if (this.customerGroup && this.price.type !== 'group') {
            //     types.map(type => {
            //         if (type.value === 'group')
            //             type.disabled =
            //                 _.includes(this.usedCustomerGroupIDs, this.customerGroup.id) || this.customerGroup.default;
            //     });
            // }

            return [{ value: 'group', label: this.$t('Customer group price') }];
        },
        taxOptions() {
            // let options = []
            // if (this.options.tax.items.filter(el => el.default === true && el.reduced === false).length) {
            //     options.push({
            //         id: 'regular',
            //         reduced: false,
            //         label: this.$t('Regular')
            //     })
            // }
            // if (this.options.tax.items.filter(el => el.default === true && el.reduced === true).length) {
            //     options.push({
            //         id: 'reduced',
            //         reduced: true,
            //         label: this.$t('Reduced')
            //     })
            // }
            // const percentages = this.options.tax.items.filter(el => el.default !== true)
            // return [...options, ...percentages]

            return [{ id: 'inherit', label: this.$t('Inherit') }];
        },
        customerGroupOptions() {
            return this.options.customerGroup.items;
        },
        disabledCustomerGroups() {
            const disabledCount = _.filter(this.customerGroupOptions, customerGroup =>
                this.isCustomerGroupDisabled(customerGroup)
            ).length;

            return disabledCount >= this.customerGroupOptions.length;
        }
    },
    methods: {
        isCustomerGroupDisabled(customerGroup) {
            if (this.disabledCustomerGroupIds) {
                return this.disabledCustomerGroupIds.includes(customerGroup.id);
            }

            if (this.price.type !== 'group') return false;

            return _.includes(this.usedCustomerGroupIDs, customerGroup.id);
        },
        customerGroupLabel(customerGroup) {
            return customerGroup.default ? `${customerGroup.name} ★` : customerGroup.name;
        },
        update(price, field, value) {
            if (this.scope === 'stepper') {
                this.$set(price, field, value)
            } else if (this.scope === 'form') {
                this.updatePrice({ price, field, value });
            }
        },
        deletePrice(value) {
            this.$emit('delete', value)
        },
        updatePrice(value) {
            this.$emit('update', value)
        },
    }
}
</script>
